import React from 'react';

import { IconSocialFacebook, IconSocialInstagram, IconSocialMedium } from '@ergeon/icons/react';

import { SocialLinksProps } from './types';

const SOCIAL_LINKS = [
  {
    name: 'Facebook',
    href: 'https://www.facebook.com/eraborhood',
    Icon: IconSocialFacebook,
  },
  {
    name: 'Instagram',
    href: 'https://www.instagram.com/ergeon/',
    Icon: IconSocialInstagram,
  },
  {
    name: 'Medium',
    href: 'https://medium.com/@ergeon',
    Icon: IconSocialMedium,
  },
];

const SocialLinks: React.FC<SocialLinksProps> = ({ className = '' }) => {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      {SOCIAL_LINKS.map((social) => (
        <a
          aria-label={social.name}
          className="text-gray-400 hover:text-gray-600"
          href={social.href}
          key={social.name}
          rel="noopener noreferrer"
          target="_blank">
          <social.Icon className="size-6" />
        </a>
      ))}
    </div>
  );
};

export default SocialLinks;
